import { Row } from '@cuemath/comps';
import styled from 'styled-components';

export const TransferListFooter = styled(Row)`
  width: 100%;
  gap: 24px;
  margin-top: 16px;
`;
